export default {"src":"/_next/static/media/Group-25755.0dd2dc43.svg","height":255,"width":439};